import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { UserService } from '../user.service';
import { User } from '../../model/user';
import { Router, ActivatedRoute, Params } from '@angular/router';
const alertify = require('alertifyjs');

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  identity: User ={};
  logged: boolean;

  constructor(
    public auth: AuthService,
    public userService: UserService,
    private router: Router
    ) {
     // auth.handleAuthentication();
  }

  ngOnInit() {
    setTimeout(() => {
      if (!this.userService.isTokenExpired()) {
      this.identity = this.userService.identity;
      this.logged = true;
      } else {
      this.identity = {};
      this.logged = false;
      }
    }, 300);
  }

  login() {
    this.userService.login(this.identity.email, this.identity.password).subscribe(success => {
      alertify.success('Success!');
      this.router.navigate(['/']);
    },
    error => {
      alertify.error('Error!');
    });
  }

  logout() {
    this.userService.logout();
    window.location.reload();
    alertify.success('Success!');
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts